export default {
  isLoading: false,
  isModalWizardLoading: false,
  // Listas que seran alimentadas por endPoint
  centrosList: [],
  isOpenModalEditWeek: false,
  isOpenModalConflictWeek: false,
  isOpenModalDeleteBlocking: false,
  dataBlockingToDelete: null,
  appointment: {},
  appointmentEditWeek: {},
  feriadosAdministrativos: [],
  isDownloadExcel: false,
  isModalNameAndConflictOpen: false,
  centerId: null,
  centerConfig: {
    minWorkDay: null,
    maxWorkDay: null,
    minSatWork: null,
    maxSatWork: null,
    minSunWork: null,
    maxSunWork: null,
    canOverBookCiel: true,
    maxOverBookCiel: null,
    canOverBookOcupational: true,
    maxOverBookOcupational: null,
    canOverBookPreocupational: true,
    maxOverBookPreocupational: null,
    listDaysWorking: [],
    listExamPools: [],
    listExams: [],
    listCiel: [],
  },
  validationBlocking: {
    quotes: 0,
    openValidation: false,
    message: null,
  },
  configList: [],
  // Fin Listas que seran alimentadas por endPoint
  steps: {
    isNewApertura: false,
    stepOne: true, // configuracion de bloqueo
    stepTwo: false, // Ingreso baterias/prestaciones / ciel
    stepThree: false, // Matriz de cupos
    stepSuccess: false, // termino de ingreso bloqueo
  },
  isBackStep: false,
  isPopupWizardOpen: false,
  configSchedulerWizard: {
    startDayHour: 9,
    endDayHour: 17,
    cellDuration: 30,
  },
  listaAppointments: null,
  weekAppointments: null,
  // lo que se va almacenando en el wizard
  blocking: {
    Id: 0,
    IdConfig: null,
    IdCentro: null,
    isNewConfig: true,
    NameBlocking: null,
    startDate: null,
    endDate: null,
    workDays: [],
    startWorkDay: null,
    endWorkDay: null,
    weekWorking: true,
    satWorkstart: null,
    satWorkEnd: null,
    sunWorkStart: null,
    sunWorkEnd: null,
    satWorking: false,
    sunWorking: false,
    moduleTime: null,
    priorityData: [],
    timeStep: 15,
    data: [],
    completeData: [],
    dataPage: 0,
    dataPageLength: 0,
    ExamPools: [], // baterias
    Exams: [],
    Ciel: [],
    blockingData: null,
    comment: null,
    pagerStartDate: null,
    blockingReason: null,
    BlockAll: false,
  },
  modulesConfig: [],
  listQuotes: [],

};
